export default __webpack_public_path__ + "static/media/google.958ae40f.svg";